import * as actionTypes from '../actions/types';

const initialState = {
  id: '',
  fullChallenge: '',
  companyGoal: '',
  measureOne: '',
  measureTwo: '',
  measureThree: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_BUSINESS_CHALLENGE_ID:
      return {
        ...state,
        id: action.id,
      };
    case actionTypes.ADD_COMPANY_GOAL:
      return {
        ...state,
        companyGoal: action.companyGoal,
      };
    case actionTypes.ADD_MEASURE_ONE:
      return {
        ...state,
        measureOne: action.measureOne,
      };
    case actionTypes.ADD_MEASURE_TWO:
      return {
        ...state,
        measureTwo: action.measureTwo,
      };
    case actionTypes.ADD_MEASURE_THREE:
      return {
        ...state,
        measureThree: action.measureThree,
      };
    case actionTypes.ASSEMBLE_FULL_CHALLENGE:
      return {
        ...state,
        fullChallenge: action.fullChallenge,
      };

    default:
      return state;
  }
};
